<!--
  Image aligned right with no text wrap. See ImageAlignLeftIcon for the shared
  geometry and why the text bars sit above and below rather than beside; only the
  tile's x origin differs (11 here).
-->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="currentColor"
    aria-hidden="true"
  >
    <rect x="2" y="2.5" width="20" height="1.6" rx="0.8" opacity="0.5" />
    <path
      fill-rule="evenodd"
      d="M12.5 6.5h8a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5V8a1.5 1.5 0 0 1 1.5-1.5Z
         M12.6 16 L15.5 11.6 L17.3 14.2 L18.4 12.9 L20.4 16 Z"
    />
    <rect x="2" y="19.9" width="20" height="1.6" rx="0.8" opacity="0.5" />
  </svg>
</template>

<script>
export default {
  name: 'ImageAlignRightIcon'
};
</script>
